import {Component, OnInit, Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Model_Datasource, Model_WorkflowComponent, Model_VariableEnvironnement, TYPE_DEFAULT_VALUE } from 'src/app/app.models';
import { FormBuilder } from '@angular/forms';

@Component({
    selector: 'app-datasource-filters-dialog',
    templateUrl: './datasource-filters-dialog.component.html',
    styleUrls: ['./datasource-filters-dialog.component.scss']
})
export class DatasourceFiltersDialogComponent implements OnInit {
    datasource: any;
    workflowComponents: Model_WorkflowComponent[] = [];
    gridComponents: Model_WorkflowComponent[] = [];
    variables: Model_VariableEnvironnement[] = [];
    formGroup = this._formBuilder.group({
        DS_FILTERS: [null]
    });
    columnsMappingOperators = [
        { VALUE: 'eq', DISPLAY: 'Egal à (=)' },
        { VALUE: 'gt', DISPLAY: 'Est supérieur à (>)' },
        { VALUE: 'gte', DISPLAY: 'Est supérieur ou égal à (>=)' },
        { VALUE: 'lt', DISPLAY: 'Est inférieur à (<)' },
        { VALUE: 'lte', DISPLAY: 'Est inférieur ou égal à (<=)' },
        { VALUE: 'ne', DISPLAY: 'Est différent de (!=)' },
        { VALUE: 'empty', DISPLAY: 'Est vide', standalone: true },
        { VALUE: 'not_empty', DISPLAY: 'N\'est pas vide', standalone: true },
    ];

    constructor(
        private _formBuilder: FormBuilder,
        public dialogRef: MatDialogRef<DatasourceFiltersDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { datasource: any, workflowComponents: Model_WorkflowComponent[], gridComponents?: Model_WorkflowComponent[], variables: Model_VariableEnvironnement[] },
    ) {
        this.datasource = data.datasource;
        this.workflowComponents = data.workflowComponents;
        this.gridComponents = data.gridComponents;
        this.variables = data.variables;
        if (!!this.datasource && !!this.datasource.DS_FILTERS) {
            this.datasource.DS_FILTERS.forEach((filter, index, filters) => { if (filter.TYPE_OPERANDE == '=') { filters[index].TYPE_OPERANDE = 'eq'; } });
            this.formGroup.controls.DS_FILTERS.patchValue(this.datasource.DS_FILTERS);
        }
    }

    ngOnInit() {
    }

    dismiss() {
        this.dialogRef.close();
    }

    onSubmit() {
        const formValues = this.formGroup.value;
        this.dialogRef.close(formValues);
    }
}